export default __webpack_public_path__ + "static/media/welcome_contratosdespesasmanutenções.9c5d79d7.png";